import { markRaw } from 'vue'
import type { RouteRecordRaw } from 'vue-router'
import { AdminReservationList } from '@myorg/booking-lib'
import api from '../../services/api'
import { ReservationRecord, ReservationAdminApi } from '@myorg/type-lib';
import {ROUTES, API_ENDPOINTS} from '@myorg/type-lib'

import { useRoute } from 'vue-router';
import  { logger } from '@myorg/type-lib';

const route = useRoute();

// 在 App 端實作介面
const adminApi : ReservationAdminApi = {
  fetchReservations: async () => {
    const response = await api().get(API_ENDPOINTS.BOOKING.RESERVATIONS);
    // 後端回傳的是物件，所以若非物件則回傳空物件 {}
    return (response.data && typeof response.data === 'object' && !Array.isArray(response.data))
      ? response.data
      : {};
  }
};
/**
 * 路由配置
 */
export const reservationRoute: RouteRecordRaw = {
  path: ROUTES.BOOKING.RESERVATION.PATH,
  name: ROUTES.BOOKING.RESERVATION.NAME,
  component: AdminReservationList,
  props: {
    api: adminApi
  }
} as RouteRecordRaw
